/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-25 10:38:27
 */

import MaintenanceStatic from "../maintenanceStatic";
import {ColDefCustom, default as AgGridVueCustomTsx} from "src/components/agGridCustom/agGridVueCustomTsx";
import MaintenanceStaticApi,{MaintenanceStaticDOI} from "../api/maintenanceStaticApi";
import ListPageService from 'src/types/ListPage';
import override from "src/dectorators/override";
import {QueryFormVOI} from "src/components/queryForm/queryForm";
import DatePicker from 'src/types/iview/DatePicker';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import EnumEntity from 'src/enums/enumEntity';
import EnumSelect from 'src/components/SelectCustom/enumSelect';

export default class MaintenanceStaticService extends ListPageService {
	ctx: MaintenanceStatic;

	constructor (ctx: MaintenanceStatic) {
	    super()
		this.ctx = ctx
	}

    @override
	createColumns (): ColDefCustom [] {
		return [
			{
				headerName: '运维站点',
				field: 'site_name',
				minWidth: 120
			},
			{
				headerName: '总计（次）',
				field: 'count',
				minWidth: 120
			},
			
		]
	}

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            
            {
                component: EnumSelect,
                label: '运维站点：',
                field: 'site_name',
                props: { value: null, type: EnumEntity.Station.getId(),useNameAsId: true },
            },
            {
                component: DatePicker,
                label: '运维时间',
                field: 'time',
                width: 300,
                timeType: 'number',
                realField: ['start_time', 'end_time'],
                props: { value: DateTimeUtil.getDayInterval(7), type: 'daterange', format: 'yyyy-MM-dd', placeholder: '请选择时间' },
            },
        ];
    }


	@override
	initSearchParams (): void {
		this.ctx.searchParams = this.ctx.queryForm.getQueryObj<MaintenanceStaticDOI.QueryRowDataParamsI>()
		this.ctx.currentPage = 1
	}

    @override
	async searchTable () {
		let ctx = this.ctx
		let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
		ag.showLoading()
		let {code, data} = await MaintenanceStaticApi.searchList({
			...ctx.searchParams,
			page_size: ctx.pageSize,
			page_index: ctx.currentPage
		})
		ag.hideLoading()

		if (code === 0) {
            let columns = this.createColumns();
            columns.splice(1,0, ...data.header.map(i => ({
                headerName: `${i.name}(次)`,
                field: i.key,
                minWidth: 100,
            })))
            this.ctx.columnDefs = columns
			ctx.rowData = data.data_info || []
			ctx.total = data.page_count
		}
	}

}